import { useFetcher } from '@aviv-unified-frontend/runtime/fetcher';
import { useServerRequest } from '@aviv-unified-frontend/runtime/lifecycle';
import { getPricePageProps } from '@/helpers/getPricePageProps/getPricePageProps';
import { normalizePath } from '@/helpers/redirect/redirect';
export const useGetPlaceData = (rawPathname) => {
    const pathname = normalizePath(rawPathname);
    const output = useServerRequest();
    const { data, isLoading, error } = useFetcher(pathname, async (key) => {
        if (output?.data?.pricePageProps && output.data.pathname === pathname) {
            return output.data.pricePageProps;
        }
        return getPricePageProps(key);
    });
    return {
        data,
        isLoading,
        error: error,
    };
};
